import { makeContextModule } from '@cian/react-utils';

import { ICoordinates } from '../types';

interface IOfferContext {
  realtyOfferId: number;
  regionId: number;
  coordinates: ICoordinates;
}

export const { Context: OfferContext, useContext: useOfferCardContext } = makeContextModule<IOfferContext>({
  contextName: 'OfferContext',
});
